/* eslint-disable import/prefer-default-export */

export const createTileCanvas = (base64Data, width, height) => {
	return new Promise((resolve, reject) => {
		const canvas = document.createElement('canvas');
		canvas.width = width; canvas.height = height;
		const ctx = canvas.getContext('2d');
		const img = new window.Image();
		img.onload = () => {
			ctx.drawImage(img, 0, 0, width, height);
			resolve(canvas);
		};
		img.onerror = reject;
		img.src = `data:image/png;base64,${base64Data}`;
	});
};
